import { Box, Typography, alpha } from '@mui/material';

interface WisdomSearchResponseStepDetailsDialogBannerProps {
  stepTitle: string;
}

export const WisdomSearchResponseStepDetailsDialogBanner = ({
  stepTitle,
}: WisdomSearchResponseStepDetailsDialogBannerProps) => {
  return (
    <Box
      py={1}
      px={3}
      bgcolor={(theme) => alpha(theme.palette.primary.main, 0.12)}
    >
      <Typography variant="body2" fontWeight={500}>
        Step: {stepTitle}
      </Typography>
    </Box>
  );
};
